import React, { useEffect, useState } from 'react';
import { databasesApi } from '../../services/api';
import StuiSelect from './StuiSelect';

// Which database a development tool reads its source schema from. These tools build shared admin
// config (field metadata, module and data-entry configs, lookup views) that every database uses,
// so they start on the template each time the page opens. Another database can be looked at, but
// the choice is never remembered: a tool left pointing at a project that drifted from the
// template would quietly build config from that drift.

export const TEMPLATE_SLUG = 'tmplt';

/**
 * { databases, source, setSource, sourceLabel, ready }. source is a DatabaseName; '' when the list
 * could not load (the API reads the template when no database is named). ready turns true once
 * the list has answered, so a page loads its schema once, from the right source.
 */
export const useSourceDatabase = () => {
  const [databases, setDatabases] = useState([]);
  const [source, setSource] = useState('');
  const [ready, setReady] = useState(false);

  useEffect(() => {
    databasesApi.getAvailable()
      .then(res => {
        const list = res.data || [];
        setDatabases(list);
        setSource(list.find(d => d.slug === TEMPLATE_SLUG)?.databaseName || '');
      })
      .catch(() => setDatabases([]))
      .finally(() => setReady(true));
  }, []);

  const current = databases.find(d => d.databaseName === source);
  const sourceLabel = current ? (current.displayName || current.name) : 'Template';
  return { databases, source, setSource, sourceLabel, ready };
};

/** The header dropdown. The template is listed first and labelled as such. */
const SourceDatabasePicker = ({ databases, value, onChange, disabled }) => {
  const ordered = [...databases].sort((a, b) =>
    (b.slug === TEMPLATE_SLUG) - (a.slug === TEMPLATE_SLUG));
  return (
    <StuiSelect className="stui-select" value={value} onChange={e => onChange(e.target.value)} disabled={disabled || !databases.length}
      title="Database to read the schema from (starts on the template)" aria-label="Source database">
      {!databases.length && <option value="">Template</option>}
      {ordered.map(d => (
        <option key={d.databaseName} value={d.databaseName}>
          {d.slug === TEMPLATE_SLUG ? `${d.displayName || d.name} (template)` : d.displayName || d.name}
        </option>
      ))}
    </StuiSelect>
  );
};

export default SourceDatabasePicker;
